<template>
    <div class="h-full" v-if="hackReset">
        <div :class="config.isDetailDisplay ? 'small-list' : 'scroll-auto'">
            <Control ref="control" :config="config" @onChangeEditDataSource="onChangeEditDataSource" @onChangeDetailDataSource="onChangeDetailDataSource"></Control>
        </div>
        <div v-show="config.isDetailDisplay" class="detail">
            <EditControl ref="editApiContrl" :dataSource="editDataSource" :config="config"></EditControl>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                config: {
                    isDetailDisplay: false,
                    dataSourceKey:null,
                    isAdd: false,
                    isCanEdit:false,
                },
                editDataSource: {},
                initialDataSource: {},
                hackReset: true,
            }
        },
        methods: {
            init: function (obj) {
                this.config = {
                    isDetailDisplay: false,
                };
                this.editDataSource = {};
                this.initialDataSource = {};

            },
            onChangeEditDataSource: function (dataSourceKey) {
                this.config.dataSourceKey = null;
                this.config.dataSourceKey = dataSourceKey;
                this.config.isAdd=true;
                if(!dataSourceKey || dataSourceKey<=0){
                    this.$refs.editApiContrl.add();
                }
            },
            syncDataSource() {
                this.initialDataSource = this.Utils.extend({}, this.editDataSource);
            },
            onChangeDetailDataSource: function (dataSourceKey) {
                this.config.dataSourceKey = null;
                this.config.dataSourceKey = dataSourceKey;
                this.config.isAdd=false;
                this.config.isCanEdit=true;
            },
            checkSaveStatus() {
                this.config.isDetailDisplay = false;
            }
        },
        components: {
            "EditControl": resolve => { require(['./components/editsiteinfo.vue'], resolve) },
            "Control": resolve => { require(['./components/siteinfo.vue'], resolve) },
        }
    }
</script>

<style>

</style>